export default {
  metadata: {
    version: '1.0.0',
    id: 'skeleton-1.0.0',
    name: 'JDSSkeleton'
  },
  hierarchy: {
    container: ['skeletonLoader']
  },
  base: {
    container: {
      hidden: false,
      'background-color': '{s_0}',
      show: true,
      overflow: 'hidden'
    },
    skeletonLoader: {
      'primary-color': '{s_1}',
      'secondary-color': '{s_2}',
      hidden: true
    }
  },
  variant: {
    shape: {
      circle: {
        container: {
          'aspect-ratio': '1',
          'border-radius': '{s_3}'
        }
      },
      heading: {
        container: {
          height: '{s_4}',
          'border-radius': '{s_5}'
        }
      },
      paragraph: {
        container: {
          'border-radius': '{s_6}',
          height: '{s_7}'
        }
      },
      rectangle: {
        container: {
          'border-radius': '{s_8}',
          'aspect-ratio': '1.77'
        }
      },
      square: {
        container: {
          'border-radius': '{s_9}',
          'aspect-ratio': '1'
        }
      },
      custom: {
        container: {
          width: '{s_10}',
          height: '{s_11}'
        }
      }
    },
    animated: {
      true: {
        skeletonLoader: {
          hidden: false
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      container: {
        width: {
          type: 'size',
          name: 'width',
          function: true,
          doc_description:
            'It can be used to determine width of all shapes od Skeleton.'
        }
      }
    },
    config: {
      shape: {
        values: [
          'circle',
          'heading',
          'paragraph',
          'rectangle',
          'square',
          'custom'
        ],
        doc_description: 'It is used to determine the shape of Skeleton.'
      },
      animated: {
        values: [false, true],
        doc_description: 'It can be used to add animantionto Skeleton.'
      }
    },
    a11y: {
      container: {
        name: 'skeleton',
        properties: {
          'aria-busy': {
            name: '_ariaBusy',
            prop: 'animated'
          },
          'aria-label': {
            name: '_ariaLabel',
            platform: 'android'
          }
        }
      }
    }
  }
};
